export var makeRowClassName = function makeRowClassName(rowNumber, displayedItemCount, classNames) {
  var even = !(rowNumber % 2);
  var Row = classNames.Row,
      RowFirst = classNames.RowFirst,
      RowLast = classNames.RowLast,
      RowEven = classNames.RowEven,
      RowOdd = classNames.RowOdd;
  return "".concat(Row, " ").concat(!rowNumber ? RowFirst : '', " ").concat(rowNumber === displayedItemCount - 1 ? RowLast : '', " ").concat(even ? RowEven : '', " ").concat(!even ? RowOdd : '').trim();
};